package pwgs.ui.scenes.projectinvitations

import kotlinx.serialization.Serializable
import pwgs.dtos.EUserLevel
import visage.ds.forms.AFieldModel
import visage.ds.forms.FieldModel
import visage.rmi.VisageController

@VisageController(ProjectInvitationsSceneProps::class, ProjectInvitationsSceneModel::class )
interface ProjectInvitations {
    fun load()
    fun inviteUser()
    fun revokeInvitation(id: String)
    fun resendInvitation(id: String)
}

@Serializable
class ProjectInvitationsSceneProps(val projectId: Long)

@Serializable
class ProjectInvitationsSceneModel(
    val invitations: List<ProjectInvitationItemModel>
) {
    var isLoading = true
    var inviteDialogModel: ProjectInvitationsSceneInviteDialogModel? = null
}

@Serializable
class ProjectInvitationItemModel(
    val id: String,
    val email: String,
    val userLevel: EUserLevel
)

@Serializable
class ProjectInvitationsSceneInviteDialogModel {
    var isLoading = false
    var error: String? = null

    var emailField = FieldModel("")
}

